export default "__VITE_ASSET__5BUsC6ml__"